<template>
    <pp-container :class="{'is-slide-right': slide}">
        <pp-slide-aside>
            <slot name="slide"></slot>
        </pp-slide-aside>
        <pp-container
            @click.native="handleContentClick" 
            @touchmove.native="move">
            <slot></slot>
        </pp-container>
    </pp-container>
</template>

<script>
/**
 * 可滑动页面容器
 * @param {boolean} slide 滑出侧边栏,支持sync修饰符
 * @param {Functon} beforeClose 关闭前调用的方法，组件会传入关闭的方法作为参数
 * @event close 关闭侧边栏时触发
 */
import ppContainer from '../../container/src/container.vue'
import ppSlideAside from '../../slide-aside/src/slide-aside.vue'

export default {
    name: 'pp-container-slide',
    props: {
        slide: Boolean,
        beforeClose: Function,
    },
    components: { ppContainer, ppSlideAside, },
    methods: {
        /**打开侧边栏 */
        openSlide: function() {
            this.$emit('update:slide', true)
        },

        /**关闭侧边栏 */
        closeSlide: function() {
            this.$emit('update:slide', false)
            this.$emit('close')
        },

        /**关闭前 */
        beforeCloseSlide: function() {
            if(typeof this.beforeClose === 'function') {
                this.beforeClose(this.closeSlide)
            }
            else {
                this.closeSlide()
            }
        },

        /**侧边栏打开状态 监听点击事件关闭 */
        handleContentClick: function() {
            this.slide && this.beforeCloseSlide()
        },

        /**侧边栏打开状态 禁止滚动*/
        move: function(e) {
            this.slide && e.preventDefault();
        },
    },
}
</script>
